import { Link } from "react-router-dom";
import { Mascot } from "./Mascot";

export const Footer = () => {
  return (
    <footer className="border-t border-[#E5DFD7] bg-white" data-testid="site-footer">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 py-12">
        <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-8">
          <div className="max-w-sm">
            <div className="flex items-center gap-2.5">
              <Mascot className="w-9 h-9 ring-2 ring-[#BBE7C6] bg-[#EBF7EE]" />
              <span className="font-display font-bold text-lg tracking-tight text-[#141915]">
                Scam<span className="text-[#15803D]">Lizard</span>
              </span>
            </div>
            <p className="mt-3 font-display italic text-[#525E54]">Before you buy the dream, check the lizard.</p>
            <p className="mt-4 text-xs leading-relaxed text-[#7B887D]">
              ScamLizard provides risk indicators and evidence summaries. Reports are informational and are not legal
              findings of fraud.
            </p>
          </div>
          <nav className="flex sm:flex-col gap-4 sm:gap-2.5" aria-label="Footer">
            <a href="#/" onClick={(e) => e.preventDefault()} data-testid="footer-methodology-link" className="text-sm font-medium text-[#525E54] hover:text-[#15803D] transition-colors">
              Methodology
            </a>
            <a href="#/" onClick={(e) => e.preventDefault()} data-testid="footer-about-link" className="text-sm font-medium text-[#525E54] hover:text-[#15803D] transition-colors">
              About
            </a>
            <a href="#/" onClick={(e) => e.preventDefault()} data-testid="footer-contact-link" className="text-sm font-medium text-[#525E54] hover:text-[#15803D] transition-colors">
              Contact
            </a>
          </nav>
        </div>
        <div className="mt-10 border-t border-[#E5DFD7] pt-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <span className="font-mono text-[10px] font-semibold uppercase tracking-[0.16em] text-[#7B887D]">
            Informational reports • Not legal findings
          </span>
          <Link to="/" className="font-mono text-[10px] font-semibold uppercase tracking-[0.16em] text-[#15803D] hover:underline" data-testid="footer-home-link">
            Back to Top 10
          </Link>
        </div>
      </div>
    </footer>
  );
};
